module.exports = __webpack_public_path__ + "img/DOG11@2x.c17fe009.png";